<div class="text-items">
    <p class="text-items__title">{{'RESET_PASSWORD' | translate}}
    </p>

    <p class="text-items__description">
        {{'PASSWORD_INSTRUCTIONS' | translate}}</p>

    <p class="text-items__description">
        <span >
            {{'ALREADY_ONE_ACCOUNT' | translate}}</span>
        <a [routerLink]="'/login' | localize" class="link link--action link--emphasized"
            >{{'GO_TO_LOGIN' | translate}}</a>
    </p>
</div>
